<template>
  <BaseModal @close="$emit('close')" :header="header" :show="show">
    <template v-slot:content>
      <div
        v-if="description"
        class="grey-4-color"
        style="
          text-align: center;
          font-size: 15px;
          line-height: 18px;
          max-width: 100%;
          margin: 0 auto 10px;
        "
        v-html="description"
      ></div>

      <div class="modal-nav" style="display: flex;">
        <button
          type="button"
          class="btn btn-bordered btn-md modal-btn"
          @click="$emit('close')"
        >
          {{ $t("buttons.cancel") }}
        </button>
        <BaseButton
          :is-load="isLoadingButton"
          :disabled="isLoadingButton"
          variant="primary"
          :color="buttonColor"
          size="lg"
          class="btn-delete modal-btn"
          @click="$emit('action')"
        >
          {{ buttonTextComputed }}
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>

<script>
export default {
  name: "ConfirmationModal",
  emits: ["action", "close"],
  props: {
    header: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      required: false
    },
    description: {
      type: String,
      required: true
    },
    isLoadingButton: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonText: {
      type: String,
      default: null
    },
    buttonColor: {
      type: String,
      default: "red-3"
    },
    buttonVariant: {
      type: String,
      default: "primary"
    }
  },
  computed: {
    buttonTextComputed() {
      return this.buttonText || this.$t("buttons.delete");
    }
  }
};
</script>


<style lang="scss" scoped>
.modal-nav {
  display: flex;
  flex-wrap: nowrap !important;

  .modal-btn {
    flex: 1;
    width: calc(50% - 6px);
    min-width: calc(50% - 6px);
    max-width: calc(50% - 6px);
  }
}
</style>
